namespace Serenity {
    @Decorators.registerClass("Serenity.FilterDisplayBar")
    export class FilterDisplayBar extends FilterWidgetBase<any> {
        constructor(div: JQuery) {
            super(div);

            const $edit = this.element.find(".edit"),
                $reset = this.element.find(".reset");
            this.element.find(".cap").text(Q.text("Controls.FilterPanel.EffectiveFilter"));
            $edit.text(Q.text("Controls.FilterPanel.EditFilter"));
            $reset.attr("title", Q.text("Controls.FilterPanel.ResetFilterHint"));

            const openFilterDialog = (event: JQueryEventObject) => {
                event.preventDefault();
                const dialog = new FilterDialog();
                dialog.get_filterPanel().set_store(this.get_store());
                dialog.dialogOpen(null);
            };

            $edit.on("click", openFilterDialog);
            this.element.find(".txt").on("click", openFilterDialog);
            $reset.on("click", (event: JQueryEventObject) => {
                event.preventDefault();
                (ss as any).clear(this.get_store().get_items());
                this.get_store().raiseChanged();
            });
        }

        protected filterStoreChanged() {
            super.filterStoreChanged();
            let displayText = Q.trimToNull(this.get_store().get_displayText());
            this.element.find(".current").toggle(displayText != null);
            this.element.find(".reset").toggle(displayText != null);

            if (displayText == null) {
                displayText = Q.text("Controls.FilterPanel.EffectiveEmpty");
            }

            this.element.find(".txt").text(`[${displayText}]`);
        }

        protected getTemplate() {
            return '<div><a class="reset"></a><a class="edit"></a><div class="current"><span class="cap"></span><a class="txt"></a></div></div>';
        }
    }
}